export const EVENT_NAMES = {
  BUTTON_CLICK: "Button Click",
  FAILED_API_CALL: "Failed API call",
  SHELL_LOGIN_CLICKED: "Shell Login Click",
  NON_SHELL_LOGIN_CLICKED: "Non Shell Login Click",
  DASHBOARD_PAGE_CLICKED: "Dashboard Page Clicked",
  SITE_DETAILS_PAGE_CLICKED: "Site Details Page Clicked",
};
